module.exports = __webpack_public_path__ + "static/media/DocumentationIcon_grey.a684eda1.svg";